import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
@Component({
  selector: 'app-learnmore-form-data',
  templateUrl: './learnmore-form-data.component.html',
  styleUrls: ['./learnmore-form-data.component.css']
})
export class LearnmoreFormDataComponent implements OnInit {

  public type: string;
  public url: string;
  public queryparams: any;
  constructor(
    private activeRoute: ActivatedRoute,
    private activeModal: NgbActiveModal,
    private lsService : SessionStorageService
    ) { }

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe((param) => {
      if (param.type) {
        this.type = param.type;
        this.url = "Register";
        this.queryparams = { type: param.type };
        this.lsService.setLSItem('type', this.type)
      }
    });
  }

  closeModal(){
    this.activeModal.dismiss();
  }
}
